var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"PicPackageButtonPrice"},[_c('div',{staticClass:"pic-price"},[_c('span',{staticClass:"pic-child-num"},[_vm._v("购买此包")]),_vm._v(" "),_c('span',{staticClass:"pic-child-num"},[_vm._v("/"+_vm._s(_vm.picPackageInfo.number - 1)+"张")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }